import React, { useRef } from 'react';
import InlineSVG from 'react-inlinesvg';

import cx from 'classnames';

import { resolveSrc } from '../utils/resolveSrc';
import Intrinsic from './Intrinsic/index';
import { ISvg } from './interface';
import './style/index.scss';

/**
 * Wrapped `react-inlinesvg`, extends `react-inlinesvg` component props
 *
 * @see https://npm.im/react-inlinesvg
 */
const SVG: React.FC<ISvg> = ({
  className,
  src,
  autoResolveSrc = true,
  style,
  width,
  height,
  responsive,
  defaultColor,
  ...props
}) => {
  const ref = useRef(null);
  const [useFallback, setUseFallback] = React.useState(false);

  React.useEffect(() => {
    setUseFallback(false);
  }, [src]);

  const componentClass = 'nord-svg';
  const classes = cx(
    componentClass,
    responsive && `${componentClass}--responsive`,
    !defaultColor && `${componentClass}--fill`,
    'inline-block',
    className
  );

  const styles = { ...style, ...(responsive ? {} : { width, height, minWidth: width }) };

  const placeholder = (
    <svg ref={ref} width={width || 0} height={height || 0} style={styles} className={classes} />
  );

  //    canUseDOM && inView &&
  // autoResolveSrc ? resolveSrc(src) :
  const element = !useFallback ? (
    <InlineSVG
      className={classes}
      style={styles}
      loader={width && height ? placeholder : undefined}
      src={autoResolveSrc ? resolveSrc(src) : src}
      onError={() => setUseFallback(true)}
      focusable={false}
      {...props}
    />
  ) : (
    placeholder
  );

  return responsive && width && height ? (
    <Intrinsic ref={ref} width={width} height={height}>
      {element}
    </Intrinsic>
  ) : (
    element
  );
};

export default SVG;
